import { render, staticRenderFns } from "./Submanufacturing.vue?vue&type=template&id=3b898cfa"
import script from "./Submanufacturing.vue?vue&type=script&lang=js"
export * from "./Submanufacturing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports